module.exports = __webpack_public_path__ + "static/media/Email.b69691d9.png";